import { render } from "./AchBankDialog.vue?vue&type=template&id=820d1972&scoped=true"
import script from "./AchBankDialog.vue?vue&type=script&lang=js"
export * from "./AchBankDialog.vue?vue&type=script&lang=js"

import "./AchBankDialog.vue?vue&type=style&index=0&id=820d1972&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-820d1972"]])

export default __exports__